import React from 'react'
import PropTypes from 'prop-types'
import 'react-datepicker/dist/react-datepicker.css'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Button,
  Label,
} from 'reactstrap'
import moment from '../../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import uniqBy from 'lodash/uniqBy'
import styled from 'styled-components'
import { statusColor } from '../helpers/color'
import "../../../static/css/index.css"
import { FONTS, COLORS } from '../../../constants'

export const TimesheetDetail = (props) => {
  const { open, request, projects, users } = props
  const { toggle, viewTimesheet } = props
  const can_approve = get(request, 'can_approve')

  return (
    /* eslint no-underscore-dangle: 0 */
    <Modal
      isOpen={ open }
      toggle={ () => toggle() }
    >
      <ModalHeader toggle={ () => toggle() }>
        <HeadLabel>Timesheet Request</HeadLabel>
      </ModalHeader>
      <ModalBody>
        <Container>
          <LabelText>Name</LabelText>
          <Row>
            <Col>
              <Text>{ `${get(request, 'name')} (${get(request, 'nick_name')})` }</Text>
            </Col>
          </Row>
          <LabelText>Period</LabelText>
          <Row>
            <Col>
              <Text>{ get(request, 'timesheet_snapshot.month') ? `${moment(get(request, 'timesheet_snapshot.month')).format('MMMM')} ${moment(get(request, 'timesheet_snapshot.month')).format('YYYY')}` : '-' }</Text>
            </Col>
          </Row>
          <LabelText>Project</LabelText>
          <Row>
            <Col>
              { uniqBy(get(request, 'timesheet_snapshot.projects', []), 'project_id').map(project => {
                const proj = find(projects, { _id: project.project_id }) || {}
                return (
                  <Text>{ proj ? `${get(proj, 'project_code', '-')}: ${get(proj, 'name', '')}` : '' }</Text>
                )
              })
              }
            </Col>
          </Row>
          <LabelText>Approver</LabelText>
          <Row>
            <Col>
              { uniqBy(get(request, 'timesheet_snapshot.projects', []), 'approver_id').map(project => {
                const approver = find(users, { _id: project.approver_id }) || {}
                const status = find(get(request, 'approve_status', []), { approver_id: project.approver_id }) || {}
                return (
                  <div style={ { display: 'flex' } }>
                    <Circle color={ statusColor(status ? get(status, 'status') : '') } />
                    <Text>{ approver ? `${get(approver, 'first_name', '')} ${get(approver, 'last_name', '')} (${get(approver, 'nick_name', '')})` : '' }</Text>
                  </div>
                )
              }) }
            </Col>
          </Row>
          <LabelText>Status</LabelText>
          <Row>
            <Col>
              <Text color={ statusColor(request.status) }>{ request.status }</Text>
            </Col>
          </Row>
          <LabelText>Submitted Date</LabelText>
          <Row>
            <Col>
              <Text>{ moment(request.updated).format('DD/MM/YYYY') }</Text>
            </Col>
          </Row>
          <LabelText>Remarks</LabelText>
          <Row>
            <Col>
              <Text>{ request.remark_request_user }</Text>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter style={ { borderTop: 'none' } }>
        <CustomButton color='success' onClick={ () => viewTimesheet(can_approve) }>View Timesheet</CustomButton>
      </ModalFooter>
    </Modal>
  )
}

TimesheetDetail.propTypes = {
  open: PropTypes.bool,
  request: PropTypes.object,
  projects: PropTypes.array,
  users: PropTypes.array,
  toggle: PropTypes.func,
  viewTimesheet: PropTypes.func,
}
TimesheetDetail.defaultProps = {
  open: false,
  request: {},
  projects: [],
  users: [],
  toggle: () => {},
  viewTimesheet: () => {},
}

export default TimesheetDetail

const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const LabelText = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: ${COLORS.BLACK};
`
const Text = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  color: ${props => { return props.color ? props.color : 'black' }};
`
const HeadLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
  padding-left: 15px;
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${props => { return props.color }};
  border-radius: 50%;
  margin-right: 8px;
  margin-top: 8px
`



// WEBPACK FOOTER //
// ./src/components/timesheet/form/timesheet-detail.js